import { LitElement } from 'lit';

/**
 * Used as base class for elements controlling a flens slider.
 */
export class FlensSliderController extends LitElement {
	static properties = {
		controls: { type: String },
	};

	constructor() {
		super();
		this._controlledSlider = null;
		this.controls = '';
	}

	/** @returns {FlensSlider|null} */
	get controlledSlider() {
		return this._controlledSlider;
	}

	connectedCallback() {
		this._updateControlledSlider();
		super.connectedCallback();
	}

	disconnectedCallback() {
		this._controlledSlider = null;
		super.disconnectedCallback();
	}

	/** @returns {HTMLElement|null} */
	_findControlledSlider() {
		if (this.controls) {
			return document.getElementById(this.controls);
		}
		const slider =
			this.closest('flens-slider') || this.parentElement?.parentNode?.host;
		if (slider) {
			this.controls = slider.id;
		}
		return slider;
	}

	_updateControlledSlider() {
		this._controlledSlider = this._findControlledSlider();
	}

	updated(_changedProperties) {
		if (_changedProperties.has('controls')) {
			this._updateControlledSlider();
		}
		super.updated(_changedProperties);
	}
}
